import { ViewBooking } from "collins-js-sdk";
import {
  Banknote,
  Briefcase,
  CheckCheck,
  CircleCheckBig,
  Link
} from "lucide-react";
import React from "react";
import { IoWalk } from "react-icons/io5";
import { BookingLabelsEnum } from "../../../../../../../types/bookingEnums";
import { getCustomerName } from "../../../../../../../utils/booking";
import { WebViewTooltip } from "../../../../SubHeader/WebViewTooltip";

interface DiaryBookingCardCustomerNameSectionProps {
  booking: ViewBooking;
  isOnRunSheet?: boolean;
}

export const DiaryBookingCardCustomerNameSection =
  React.memo<DiaryBookingCardCustomerNameSectionProps>(
    ({ booking, isOnRunSheet }) => {
      if (booking.walkIn) {
        return (
          <div className="DiarySidebarListItem_walkIn">
            <IoWalk /> <span>Walk In</span>
          </div>
        );
      }

      const renderRunsheetIcons = () => {
        if (!isOnRunSheet) {
          return null;
        }

        return (
          <>
            {booking.doubleConfirmed && (
              <WebViewTooltip content="Double Confirmed" side="bottom">
                <CheckCheck
                  size={18}
                  style={{
                    color: "var(--primaryColor, #f2f2f2)",
                    flexShrink: 0
                  }}
                />
              </WebViewTooltip>
            )}
            {((booking.linkedBookings?.length ?? 0) !== 0 ||
              booking.labels?.find(
                (LinkedBooking: string) =>
                  LinkedBooking === BookingLabelsEnum.LinkedBooking
              ) === BookingLabelsEnum.LinkedBooking) && (
              <WebViewTooltip content="Linked Booking" side="bottom">
                <Link
                  size={18}
                  style={{
                    color: "var(--primaryColor, #f2f2f2)",
                    flexShrink: 0
                  }}
                />
              </WebViewTooltip>
            )}
            {booking.company?.[0] && (
              <WebViewTooltip content="Company Booking" side="bottom">
                <Briefcase
                  size={18}
                  style={{
                    color: "var(--primaryColor, #f2f2f2)",
                    flexShrink: 0
                  }}
                />
              </WebViewTooltip>
            )}
            {(booking.deposits?.length ?? 0) !== 0 && (
              <WebViewTooltip content="Has Deposit" side="bottom">
                <Banknote
                  size={18}
                  style={{
                    color: "var(--primaryColor, #f2f2f2)",
                    flexShrink: 0
                  }}
                />
              </WebViewTooltip>
            )}
            {(booking.autoConfirmed ||
              booking.labels?.find(
                (AutoConfirmed: string) =>
                  AutoConfirmed === BookingLabelsEnum.AutoConfirmed
              ) === BookingLabelsEnum.AutoConfirmed) && (
              <WebViewTooltip content="Auto Confirmed" side="bottom">
                <CircleCheckBig
                  size={18}
                  style={{
                    color: "var(--primaryColor, #f2f2f2)",
                    flexShrink: 0
                  }}
                />
              </WebViewTooltip>
            )}
          </>
        );
      };

      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            fontWeight: 800,
            overflow: "hidden",
            minWidth: 0
          }}
          className="DiarySidebarListItem__customerName"
        >
          {isOnRunSheet ? (
            <>
              <span>{getCustomerName(booking)}</span>
              {renderRunsheetIcons()}
            </>
          ) : (
            <WebViewTooltip
              content={getCustomerName(booking)}
              showOnlyWhenTruncated={true}
            >
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  minWidth: 0,
                  flex: 1
                }}
              >
                {getCustomerName(booking)}
              </span>
              {renderRunsheetIcons()}
            </WebViewTooltip>
          )}
        </div>
      );
    }
  );

DiaryBookingCardCustomerNameSection.displayName =
  "DiaryBookingCardCustomerNameSection";
